import React from "react";
import Otherheader from "../Header/Otherheader";
import Whatsapp from "../Whatsapp/Whatsapp";
import medicaltoursim from "../../assets/medicaltoursim.png";
import "./Services.css";
import { SlBadge } from "react-icons/sl";
import { FaUserDoctor } from "react-icons/fa6";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { BiSupport } from "react-icons/bi";
import { CiLocationOn } from "react-icons/ci";
import { MdGroups } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import doc_img from "../../assets/doc_img.webp";
import doc_about1 from "../../assets/doc_about1.webp";
import shubham from "../../assets/shubham.webp";

export const MedicalTourism = () => {
  return (
    <div>
      <Otherheader />
      <Whatsapp />
      <div className="medicaltourism">
        <div className="medicalbnanner">
          <div>
            <h2 style={{fontWeight:"bold"}}>Medical Tourism at Sharva Clinic</h2>
            <p>
              Sharva Clinic is a modern healthcare center in New Delhi, India,
              offering high-quality medical and aesthetic treatments to patients
              from across the globe. We welcome international patients seeking
              reliable medical care, personalized attention, and cost-effective
              treatment options without compromising safety or outcomes.
            </p>
            <p>
              Our clinic combines experienced doctors, advanced medical
              techniques, and patient-focused care to ensure a smooth and
              comfortable medical journey for every visitor.
            </p>
          </div>
          <img src={medicaltoursim} alt="" />
        </div>
        <div className="medicalchooseus">
          <h2 style={{fontWeight:"bold"}}>Why International Patients Choose Sharva Clinic</h2>
          <div className="medical_point">
            <div className="cards1">
              <SlBadge
                style={{
                  color: "#D59F18",
                  fontSize: "50px",
                  marginBottom: "20px",
                }}
              />
              <h5 style={{fontWeight:"600"}}>Experienced and Specialized Doctors</h5>
              <p style={{fontSize:"14px"}}>
                Sharva Clinic is led by qualified specialists in cosmetology,
                respiratory medicine, and general healthcare. Each patient is
                treated by doctors with strong clinical experience and a
                careful, ethical approach to care.
              </p>
            </div>
            <div className="cards2">
              <FaUserDoctor
                style={{
                  color: "#D59F18",
                  fontSize: "50px",
                  marginBottom: "20px",
                }}
              />
              <h5 style={{fontWeight:"bold"}}>Personalized Treatment Plans</h5>
              <p style={{fontSize:"14px"}}>
                We understand that every patient’s medical needs are different.
                Treatment plans are customized based on individual health
                conditions, goals, and travel timelines, ensuring effective and
                realistic outcomes.
              </p>
            </div>
            <div className="cards3">
              <FaIndianRupeeSign
                style={{
                  color: "#D59F18",
                  fontSize: "50px",
                  marginBottom: "20px",
                }}
              />
              <h5 style={{fontWeight:"bold"}}>High-Quality Care at Affordable Costs</h5>
              <p style={{fontSize:"14px"}}>
                International patients benefit from world-class medical services
                at a significantly lower cost compared to many other countries,
                without compromising on safety, hygiene, or treatment standards.
              </p>
            </div>
            <div className="cards4">
              <MdGroups
                style={{
                  color: "#D59F18",
                  fontSize: "50px",
                  marginBottom: "20px",
                }}
              />
              <h5 style={{fontWeight:"bold"}}>Clear Communication in English</h5>
              <p style={{fontSize:"14px"}}>
                Our doctors and support staff communicate clearly in English,
                making it easy for international patients to understand their
                diagnosis, treatment options, and aftercare instructions.
              </p>
            </div>
            <div className="cards5">
              <BiSupport
                style={{
                  color: "#D59F18",
                  fontSize: "50px",
                  marginBottom: "20px",
                }}
              />
              <h5 style={{fontWeight:"bold"}}>Support for Medical Travel and Documentation</h5>
              <p style={{fontSize:"14px"}}>
                We assist patients with appointment confirmations, treatment
                letters, and guidance for medical visas, helping make the travel
                and treatment process smooth and stress-free.
              </p>
            </div>
            <div className="cards6">
              <FaLocationDot
                style={{
                  color: "#D59F18",
                  fontSize: "50px",
                  marginBottom: "20px",
                }}
              />
              <h5 style={{fontWeight:"bold"}}>Comfortable Location and Patient-Focused Care</h5>
              <p style={{fontSize:"14px"}}>
                Located in New Delhi, Sharva Clinic is easily accessible from
                international airports and nearby accommodations. We focus on
                patient comfort, privacy, and attentive care throughout the
                treatment journey.
              </p>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="intro-section">
            <h2 style={{fontWeight:"700"}}>Our Dedicated Specialists Committed to Exceptional Patient Care</h2>
            <p>
              Sharva Clinic offers a wide range of outpatient services
              suitable for international patients:
            </p>
          </div>

          <div class="services-grid">
            <div class="service-card cosmetic" style={{marginBottom:"30px"}}>
              <div class="service-content">
                <img src={doc_img} alt="" />
                <div className="drsweta">
                  <h3 style={{fontWeight:"600"}}>Dr. Sweta Mishra</h3>
                  <p>
                    Our cosmetic services focus on enhancing natural appearance
                    using advanced, non-surgical techniques performed by
                    experienced specialists.
                  </p>
                  <ul>
                    <li>Facial aesthetic treatments</li>
                    <li>Cosmetic procedures for skin rejuvenation</li>
                    <li>Acne and acne scar management</li>
                    <li>Anti-aging treatments</li>
                    <li>Non-surgical facial contouring and enhancement</li>
                    <li>Facial corrective and reconstructive procedures</li>
                  </ul>
                   <a href="/appoint">
                  <button className="servicebtn">Book Appointment</button>
                  </a>
                </div>
              </div>
            </div>

            <div class="service-card pulmonary" style={{marginBottom:"30px"}}>
              <div class="service-content1" >
                <div className="drgaurav">
                  <h3 style={{fontWeight:"600"}}>Dr. Gaurav Pandey</h3>
                  <p>
                    We offer expert consultation and long-term care for
                    respiratory health conditions with a focus on accurate
                    diagnosis and ongoing management.
                  </p>
                  <ul>
                    <li>Diagnosis and treatment of respiratory diseases</li>
                    <li>Chronic cough and breathing disorders</li>
                    <li>Asthma and allergy management</li>
                    <li>Lung health evaluation</li>
                    <li>Second opinions for respiratory conditions</li>
                  </ul>
                   <a href="/appoint">
                  <button className="servicebtn">Book Appointment</button>
                  </a>
                </div>
                <img src={doc_about1} alt="" />
              </div>
            </div>

            <div class="service-card general" style={{marginBottom:"30px"}}>
              <div class="service-content">
                <img src={shubham} alt="" />
                <div className="drshubham">
                  <h3 style={{fontWeight:"600"}}>Dr. Shubham Pandey</h3>
                  <p>
                    Our general healthcare services support overall wellness,
                    preventive care, and ongoing medical monitoring for
                    international patients.
                  </p>
                  <ul>
                    <li>General medical consultations</li>
                    <li>Preventive health check-ups</li>
                    <li>Routine diagnostics and evaluations</li>
                    <li>Chronic disease management</li>
                    <li>Coordination of specialist care</li>
                  </ul>
                   <a href="/appoint">
                  <button className="servicebtn">Book Appointment</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h2 className="" style={{ marginTop: "40px",fontWeight:"bold" }}>
            Your Journey with Us
          </h2>
          <div class="cards-container">
            <div class="card">
              <h3 class="card-title">1</h3>
              <p class="card-text">
                Your journey begins with an online consultation where we review
                your medical history, reports, and treatment expectations.
              </p>
            </div>

            <div class="card">
              <h3 class="card-title">2</h3>
              <p class="card-text">
                Our doctors create a customized treatment plan tailored to your
                medical needs, schedule, and recovery goals.
              </p>
            </div>

            <div class="card">
              <h3 class="card-title">3</h3>
              <p class="card-text">
                We assist with appointment confirmation and guide you on medical
                visa documentation for a smooth arrival.
              </p>
            </div>

            <div class="card">
              <h3 class="card-title">4</h3>
              <p class="card-text">
                From your first clinic visit to treatment completion, our team
                ensures attentive and comfortable care.
              </p>
            </div>

            <div class="card">
              <h3 class="card-title">5</h3>
              <p class="card-text">
                We provide clear aftercare instructions and ongoing follow-ups,
                even after you return home.
              </p>
            </div>

            <div class="card">
              <h3 class="card-title">6</h3>
              <p class="card-text">
                Our team remains available for post-treatment queries, ensuring
                long-term health and satisfaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
